import { h, Fragment } from "preact";
import { useState, useEffect, } from "preact/hooks";
import {

	Box,
	Divider,
	Grid,
	Stack,
	TextField,
	Typography,
} from "@mui/material";

import FormField from "../Common/FormField";

import FormToggle from "../Common/FormToggle";
import FormMultiToggle from "../Common/FormMultiToggle";
import FormNumericPlusMinus from "../Common/FormNumericPlusMinus";

import FormDate from "../Common/FormDate";
import Ges from "../GES/";
import Dpe from "../DPE/";

export default function Immeuble({ upperState, upperHandleChange }) {
	const [state, setState] = useState({ changes: false });


	const handleChange = (event) => {

		upperHandleChange(event);
	};

	return (
		<Stack spacing={1}>
			<Grid container spacing={1}>
				<Grid item md={6} xs={12} >
					<Stack spacing={1}>

						<FormField upperState={upperState} id="surface" placeholder="Surface totale de l’immeuble en m2" handleChange={handleChange} num={true} disabled={upperState.mandate_signed} helper={<Stack><Typography>Surface globale de l’immeuble, toutes surfaces comprises.</Typography></Stack>} />
						<Divider />
						<FormToggle upperState={upperState} id="has_garden" handleChange={handleChange} />
						{upperState.has_garden == "O" && <FormField upperState={upperState} id="garden_surface" placeholder="Surface du terrain en m2" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer la surface du terrain/jardin</Typography></Stack>} />}
						<Divider />

						<FormField upperState={upperState} id="floors" placeholder="Nombre de niveaux" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer le nombre d'étages de l'immeuble.</Typography></Stack>} />
						<FormField upperState={upperState} id="nb_of_flats" placeholder="Nombre total de logements" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer le nombre de lots de l'immeuble.</Typography></Stack>} />
						<Divider />
						{/* <FormToggle upperState={upperState} id="has_terrace" handleChange={handleChange} />
						{upperState.has_terrace == "O" && (<FormField upperState={upperState} id="terrace_surface" placeholder="Surface" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer la surface de la terrasse</Typography></Stack>} />)}

						<Divider /> */}
						<FormToggle upperState={upperState} id="has_business_parts" handleChange={handleChange} />
						{upperState.has_business_parts == "O" && (<FormField upperState={upperState} id="business_parts" placeholder="Nb" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer si il y a des locaux ...</Typography></Stack>} />)}

						<Divider />
						<FormToggle upperState={upperState} id="has_garage" handleChange={handleChange} />
						{upperState.has_garage == "O" && (<FormField upperState={upperState} id="parking_lots" placeholder="Nb" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer le nombre de places.</Typography></Stack>} />)}
						<Divider />
						<FormToggle upperState={upperState} id="has_cave" handleChange={handleChange} />
						{upperState.has_cave == "O" && (<FormField upperState={upperState} id="cellar_lots" placeholder="Nb" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer le nombre de caves.</Typography></Stack>} />)}

						<Divider />
						<FormToggle upperState={upperState} id="has_elevator" handleChange={handleChange} />

						<Divider />

						<FormToggle upperState={upperState} id="dpe_and_ges_available" handleChange={handleChange} helper={<Stack><Typography>Diagnostic de Performance Energétique.</Typography></Stack>} />

						{upperState.dpe_and_ges_available == "O" && (<FormField upperState={upperState} id="dpe" placeholder="DPE" handleChange={handleChange} num={true} helper={<Stack><Typography variant="body1">Reportez la valeur numérique indiquée dans le</Typography><Typography>Diagnostic de Performance Energétique.</Typography><Typography variant="h5">Etiquette énergie</Typography><Dpe nb={upperState.dpe} /></Stack>} />)}
						{upperState.dpe_and_ges_available == "O" && (<FormField upperState={upperState} id="ges" placeholder="GES" handleChange={handleChange} num={true} helper={<Stack><Typography variant="body1">Reportez la valeur numérique indiquée dans le</Typography><Typography>Diagnostic de Performance Energétique.</Typography><Typography variant="h5">Etiquette climat</Typography><Ges nb={upperState.ges} /></Stack>} />)}
						<Divider />
						<FormField upperState={upperState} id="property_tax" placeholder="€/an" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer la taxe foncière.</Typography></Stack>} />

						<Divider />
						<FormToggle upperState={upperState} id="is_connected_to_sewage" handleChange={handleChange} helper={<Stack><Typography>L'immeuble est il raccordé à un réseau public d'assainissement ?</Typography></Stack>} />
						<Divider />
						<FormMultiToggle upperState={upperState} options={[{ o: "O", l: "Oui" }, { o: "P", l: "Partiellement" }, { o: "N", l: "Non" }, { o: "?", l: "Ne sais pas" }]} id="is_not_building_free" handleChange={handleChange} exclusive={true} helper={<Stack><Typography>Indiquer la période de construction de l'immeuble.</Typography></Stack>} />

						{(upperState.is_not_building_free == "O" || upperState.is_not_building_free == "P") && (<FormField upperState={upperState} id="rent" placeholder="€/an" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer le montant du loyer annuel hors charges.</Stack>} />)}
						{/* {upperState.is_not_free == "O" && (<FormDate upperState={upperState} id="rent_term" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer la date de fin du contrat de location (bail).</Stack>} />)} */}
						{/* <FormToggle upperState={upperState} id="co_property_asl" handleChange={handleChange} helper={<Stack><Typography>ASL</Typography></Stack>} /> */}
						<Divider />
						<FormMultiToggle upperState={upperState} options={[{ o: "49", l: "Avant 1949" }, { o: "97", l: "Entre les deux" }, { o: "00", l: "Après 1996" }, { o: "?", l: "Ne sais pas" }]} id="construction_year" handleChange={handleChange} exclusive={true} helper={<Stack><Typography>Indiquer la période de construction de l'immeuble.</Typography></Stack>} />
					</Stack>
				</Grid>

			</Grid >
		</Stack>
	);
}
